import { useState } from 'react';
import { useToggle } from 'react-use';
import { Common } from '@thecvlb/design-system/lib/src';

import FAQ from 'modals/FAQ';
import RadioGroup from 'shared/RadioGroup';

import { WegovyOfferProps } from './wegovyOffer.types';

import wegovy from 'assets/images/other/wegovy.webp';

const WegovyOffer: React.FC<WegovyOfferProps> = ({ onContinue }) => {
  const [isFAQOpen, toggleIsFAQOpen] = useToggle(false);
  const [selected, setSelected] = useState('');

  const handleContinue = () => onContinue(selected === 'wegovy');

  const ITEMS = [
    {
      label: (
        <div className="flex items-center justify-between">
          <div className={selected === 'wegovy' ? 'font-bold' : 'font-semibold'}>
            <p>Wegovy</p>
            <p className="text-mSm">
              <span className=" font-bold text-green">$499/mo</span>
              <br />
              <span className="text-gray">+ care subscription ($149/mo)</span>
            </p>
          </div>
          <img alt="wegovy" className="-my-2.5 w-[52px] translate-y-2" src={wegovy} />
        </div>
      ),
      value: 'wegovy'
    },
    {
      label: 'See if I qualify for a customized semaglutide compound',
      value: 'other'
    }
  ];

  return (
    <>
      <FAQ
        isOpen={isFAQOpen}
        type="eligible"
        onClose={toggleIsFAQOpen}
        medication="semaglutide"
        screen="wegovy-offer"
      />
      <div className="flex h-full grow flex-col">
        <div className="flex flex-col gap-4 py-6">
          <div className="flex flex-col items-center gap-2 text-center">
            <p className="font-bold text-primary-700">Great news!</p>
            <h3 className="text-m2xl font-bold text-primary-700 md:text-2xl">
              You prequalify for branded Wegovy® at a lower price
            </h3>
            <p>
              Get the medication shipped directly to your door and pay the pharmacy directly.
              <br />
              <b>No insurance required.</b>
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <RadioGroup items={ITEMS} selectedItem={selected} onSelect={setSelected} />
          </div>
        </div>
        <div className="flex flex-col items-center gap-3 max-md:mt-auto md:mx-auto">
          <Common.Button
            color="blue"
            fullWidthOnMobile
            onClick={handleContinue}
            disabled={!selected}
          >
            Continue
          </Common.Button>
          <Common.Button color="white-alt" fullWidthOnMobile onClick={toggleIsFAQOpen}>
            FAQs
          </Common.Button>
        </div>
      </div>
    </>
  );
};

export default WegovyOffer;
